<template>
  <Modal :value="value" title="H5/App下载" class="vertical-center-modal" :width="900"
    footer-hide @on-visible-change="onVisible">
    <div class="dl-grid">
      <div v-for="q in qrs" :key="q.name" class="dl-col">
        <div class="dl-name">{{ q.name }}</div>
        <qrcode-block :text="q.url" :size="120" />
        <div class="dl-url">{{ q.url }}</div>
        <div class="dl-btns">
          <Button size="small" type="primary" @click="copy(q.url)">复制</Button>
          <Button v-if="q.spare" size="small" @click="copy(q.spare)">备用下载</Button>
        </div>
      </div>
    </div>
    <tip-bar type="warning">推广链接使用说明:关闭进群审核后,使用推广链接登录或注册的用户可直接进群。</tip-bar>
  </Modal>
</template>

<script>
import QrcodeBlock from '@/components/base/QrcodeBlock.vue'

export default {
  name: 'DownloadDialog',
  components: { QrcodeBlock },
  props: { value: { type: Boolean, default: false } },
  data() {
    return {
      qrs: [
        { name: '推广链接', url: 'https://demo.example.com/promo' },
        { name: 'H5扫码登录', url: 'https://demo.example.com/h5' },
        { name: 'App扫码下载1', url: 'https://demo.example.com/app1' },
        { name: 'App扫码下载2', url: 'https://demo.example.com/app2' },
        { name: '打盘助手下载', url: 'https://demo.example.com/assistant.exe', spare: 'https://demo2.example.com/assistant.exe' }
      ]
    }
  },
  methods: {
    onVisible(v) { if (!v) this.$emit('input', false) },
    copy(text) {
      navigator.clipboard && navigator.clipboard.writeText(text)
      this.$Message.success('已复制')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.dl-grid { display: flex; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.dl-col {
  flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: center;
  border: 1px solid @border-light; border-radius: @radius; padding: 12px 8px;
}
.dl-name { font-weight: 600; font-size: 13px; margin-bottom: 10px; }
.dl-url { color: @text-muted; font-size: 11px; margin: 8px 0; word-break: break-all; text-align: center; line-height: 1.4; }
.dl-btns { display: flex; gap: 6px; margin-top: auto; }
</style>
